export default "__VITE_ASSET__B94i6gPF__"